<template>
  <div class="menu-top blue">
    <v-row>
      <v-container>
        <v-row>
          <v-col>
            <v-icon class="white--text mr-2 body-1">mdi-clock-outline</v-icon>
            <span class="white--text ant-font-viga-xs mr-2">{{ jam }} WIB</span>
          </v-col>
        </v-row>
      </v-container>
    </v-row>

    <v-app-bar
      app
      light
      color="transparent"
      absolute
      style="height: 85px;"
      elevation="0"
      class="mt-10 mr-10"
    >

      <v-toolbar-title v-if="device.desktop">
        <div class="pl-5 pr-5 mr-5">
          <img
            src="/images/epkk1.png"
            width="200px"
            height="40px"
            alt="logo"
            :class="device.desktop ? `animate__animated animate__tada ant-header-logo`:`ant-header-logo-mobile`"
            @click="$router.push({name:'home'})"
          >
        </div>
      </v-toolbar-title>
      <v-list
        v-if="device.desktop"
        color="transparent"
        class="d-flex white light  mt-4  mb-5"
        style="margin-right: 150px !important;"
      >
        <template v-for="(menu,index) in menus">
          <v-list-item
            active-class="blue white--text rounded-pill animate__animated animate__bounce "
            class="hidden-sm-and-down rounded-pill mr-2"
            link
            :to="menu.route"
            v-if="menu.type=='item'"
          >
            <v-list-item-title class="font-weight-bold">{{ menu.title }}</v-list-item-title>
          </v-list-item>

          <v-menu
            offset-y
            v-if="menu.type=='subMenu'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                active-class="blue darken-1 white--text rounded-pill"
                class="font-weight-bold rounded-pill "
                v-bind="attrs"
                v-on="on"
                text
                style="text-transform: unset !important;height: 50px;"
              >
                {{ menu.title }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in menu.submenus"
                :key="index"
                :to="item.route"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </template>
      </v-list>
      <v-spacer v-if="device.desktop" />

      <v-text-field
        placeholder="Cari Produk..."
        outlined
        dense
        hide-detail
        :color="theme.color"
        class="rounded-pill mt-6 mr-2"
        append-icon="mdi-shopping-search"
        v-model="search"
      >
      </v-text-field>

      <v-badge
        bordered
        color="red"
        content="0"
        overlap
        class="mr-4 ml-2 animate__animated animate__bounce animate__delay-2s"
      >
        <v-icon
          color="green"
          class=""
        >mdi-shopping</v-icon>
      </v-badge>

      <v-menu
        v-if="device.desktop"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="mr-2"
          >

            <v-icon
              class="mr-1 ml-2"
              color="blue"
            >mdi-storefront</v-icon>

          </v-btn>
        </template>

        <v-card color="">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center">
                  <div class="text-body-2">
                    Anda belum memiliki UP2K PKK...?
                  </div>
                  <div class="mt-3">
                    <v-btn
                      color="blue"
                      small
                      class="text-transform-none white--text"
                      @click="$router.push({name:'register-umkm'})"
                    >Daftar UP2K PKK Sekarang</v-btn>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-menu
        v-if="device.desktop"
        v-model="menu"
        :close-on-content-click="true"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="mr-2"
          >
            <v-icon>
              mdi-account-circle
            </v-icon>
          </v-btn>
        </template>

        <v-card color="">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      color="blue"
                      outlined
                      dense
                      hide-details
                      class="text-transform-none"
                      @click="$router.push({name:'login'})"
                    >Masuk</v-btn>
                  </v-col>
                  <!-- <v-col
                    cols="6"
                    v-if="false"
                  >
                    <v-btn
                      color="blue"
                      class="white--text text-transform-none"
                      @click="$router.push({name:'register-user'})"
                    >Daftar</v-btn>
                  </v-col> -->
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-menu
        offset-y
        width="300"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="device.mobile"
            icon
            light
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="black">mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-card width="200">
          <v-list>
            <v-list-item>
              <v-list-item-title @click="$router.push({ name: 'home' })">
                Produk UP2K PKK
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="$router.push({ name: 'register-umkm' })">
                Registrasi UP2K PKK
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item>
              <v-list-item-title @click="$router.push({ name: 'register-user' })">
                Registrasi Pengguna
              </v-list-item-title>
            </v-list-item> -->
            <v-list-item>
              <v-list-item-title @click="$router.push({ name: 'login' })">
                Login
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
  </div>

</template>
  
  <script>
import { mapState, mapActions } from "vuex";
export default {
  name: "HeaderComponent",

  data: () => ({
    menus: [
      {
        title: "Produk UP2K PKK",
        route: "/product",
        type: "item",
        // submenus: [
        //   {
        //     title: "Seluruh Inovasi",
        //     icon: "mdi-clover",
        //     route: "/repository",
        //     type: "item",
        //   },
        //   {
        //     title: "Grafik Inovasi",
        //     icon: "mdi-clover",
        //     route: "#",
        //     type: "item",
        //   },
        //   {
        //     title: "Peta Inovasi",
        //     icon: "mdi-clover",
        //     route: "#",
        //     type: "item",
        //   },
        // ],
      },
      //   {
      //     title: "Menu 2",
      //     route: "/kompetisi",
      //     type: "subMenu",
      //     submenus: [
      //       {
      //         title: "IGA",
      //         icon: "mdi-clover",
      //         route: "#",
      //         type: "item",
      //       },
      //       {
      //         title: "SINOVIC",
      //         icon: "mdi-clover",
      //         route: "#",
      //         type: "item",
      //       },
      //     ],
      //   },
    ],
    search: null,
    jam: null,
  }),
  mounted() {
    setInterval(() => {
      this.currtime();
    }, 500);
  },
  computed: {
    ...mapState(["device", "theme", "info", "page", "user"]),
  },
  methods: {
    ...mapActions(["setSearch"]),
    currtime: function () {
      let date = new Date();
      let hh = date.getHours();
      let mm = date.getMinutes();
      let ss = date.getSeconds();
      let session = "SIANG";

      if (hh == 0) {
        hh = 12;
      }
      if (hh > 12) {
        hh = hh - 12;
        session = "MALAM";
      }

      hh = hh < 10 ? "0" + hh : hh;
      mm = mm < 10 ? "0" + mm : mm;
      ss = ss < 10 ? "0" + ss : ss;

      let time = hh + ":" + mm + ":" + ss;

      this.jam = time;
    },
  },
  watch: {
    search: function () {
      this.setSearch(this.search);
    },
  },
};
</script>
  
<style>
.menu-top {
  position: absolute;
  height: 29px;
  left: 0%;
  right: 0%;
  top: 0;
}

.v-toolbar__title {
  display: flex;
  font-size: 20px;
  font-weight: 600;
  color: cornflowerblue;
}

::before {
  border-radius: 30px;
}

span.hidden-sm-and-down.header-title {
  font-size: 20px;
  color: grey;
}

.ant-header-title {
  font-family: people;
}
.ant-header-subtitle {
  font-size: 13px;
  font-family: sans-serif;
}
.ant-header-logo {
  margin-top: 15px;
  margin-left: 150px;
}
.ant-header-logo-mobile {
  margin-left: 2px;
}
</style>